// HyperMD, copyright (c) by laobubu
// Distributed under an MIT license: http://laobubu.net/HyperMD/LICENSE
//
// POWERPACK for "addon/fold-code"
//
// This module provides `MermaidRenderer` for FoldCode addon
// so that you can render flowchart / diagram with powerful [mermaid](https://mermaidjs.github.io/)
//
// By default the renderer is enabled. You may disable it by setting `hmdFoldCode.mermaid` to `false`
//
// **Example**: https://laobubu.net/HyperMD/docs/examples/mermaid.html
//
// :hint: to change mermaid configuration
//
// :warning: **Please include mermaid via HTML tag**
//
// mermaid's module declaration is buggy (v8.0.0). HyperMD gave up importing it.
//
// If using RequireJS or bundler (eg. webpack), include `<script src="path/to/mermaid.min.js"></script>` manually,
// before RequireJS or `dist/your_app.js`
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("codemirror"), require("../addon/fold"), require("../addon/fold-code")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","codemirror","../addon/fold","../addon/fold-code"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.FoldCodeWithMermaid = this.HyperMD.FoldCodeWithMermaid || {}), CodeMirror, HyperMD.Fold, HyperMD.FoldCode);
})(function (require, exports, CodeMirror, fold_1, fold_code_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MermaidRenderer = void 0;
    CodeMirror = __importStar(CodeMirror);
    var MermaidRenderer = function (code, info) {
        var id = "_mermaid_id_" + Math.round(1e9 * Math.random()).toString(36);
        var el = document.createElement("div");
        el.setAttribute("id", id);
        el.setAttribute("class", "hmd-fold-code-image hmd-fold-code-mermaid");
        try {
            mermaid.parse(code);
            mermaid.render(id, code, function (svgCode, bindFunctions) {
                el.innerHTML = svgCode;
                el.removeAttribute("id");
                if (bindFunctions) {
                    bindFunctions(el);
                }
                if (info.changed) {
                    info.changed();
                }
            });
        }
        catch (error) {
            el.innerHTML = "<pre class=\"language-text\">" + error.str.toString() + "</pre>";
            if (info.changed) {
                info.changed();
            }
        }
        return {
            element: el,
            asyncRenderer: null,
        };
    };
    exports.MermaidRenderer = MermaidRenderer;
    if (typeof mermaid === "object") {
        CodeMirror.defineOption("mermaid", null, function (cm) {
            fold_code_1.getAddon(cm).clear("mermaid");
            fold_1.getAddon(cm).startFold();
        });
        fold_code_1.registerRenderer({
            name: "mermaid",
            pattern: /^mermaid$/i,
            renderer: exports.MermaidRenderer,
            suggested: true,
        });
    }
    else {
        if (window["ECHOMD_DEBUG"]) {
            console.error("[HyperMD] PowerPack fold-code-with-mermaid loaded, but mermaid not found.");
        }
    }
});
